export function formatTalkViewerMediaTime(playTimeSecond: number) {
  if (!playTimeSecond) {
    return '00:00';
  }
  // 톡뷰어는 미디어의 플레이타임을 올림 처리한다.
  const ceiledTime = Math.ceil(playTimeSecond);
  const minute = Math.floor(ceiledTime / 60);
  const second = ceiledTime - minute * 60;
  return `${minute < 10 ? `0${minute}` : minute}:${
    second < 10 ? `0${second}` : second
  }`;
}
